import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MobileMenu from './Mobilemenu';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Menu = ({ menuItems, onLoginClick, onSpeakClick }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const menuRef = useRef(null);
  const location = useLocation();

  const toggleDropdown = (index) => {
    setOpenDropdown((prevState) => (prevState === index ? null : index));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setOpenDropdown(null);
  }, [location]);

  return (
    <>
      <div className="main-menu" ref={menuRef}>
        <div className="menu-list">
          <ul>
            {menuItems.map((item, index) => (
              <li
                className={`menu-item ${location.pathname === item.path ? 'active' : ''} ${
                  openDropdown === index ? 'open' : ''
                }`}
                key={index}
              >
                <div className="menu-item-container">
                  <Link to={item.path}>{item.label}</Link>
                  {item.subMenu && (
                    <button
                      className="dropdown-toggle"
                      onClick={() => toggleDropdown(index)}
                      aria-haspopup="true"
                      aria-expanded={openDropdown === index ? 'true' : 'false'}
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </button>
                  )}
                </div>
                {item.subMenu && openDropdown === index && (
                  <div className="dropdown">
                    {item.subMenu.map((subItem, subIndex) => (
                      <Link
                        to={subItem.path}
                        key={subIndex}
                        onClick={() => setOpenDropdown(null)}
                      >
                        {subItem.icon && (
                          <FontAwesomeIcon icon={subItem.icon} className="submenu-item-icon" />
                        )}
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="login-container">
        <span className="secondarymenu">
          <button onClick={onLoginClick}>Log in / Register</button>
        </span>
        <span className="primarymenu">
          <button onClick={onSpeakClick}>Speak to an Expert</button>
        </span>
      </div>
      <MobileMenu menuItems={menuItems} onLoginClick={onLoginClick} onSpeakClick={onSpeakClick} />
    </>
  );
};

export default Menu;
